import React from "react";
import { calc } from "@vanilla-extract/css-utils";
import { heroContainerMediaQueries, useWindowWidth } from "@utils";

export const MockCard = ({ className, first }) => {
  const windowWidth = useWindowWidth();

  const getStyle = () => {
    if (windowWidth >= heroContainerMediaQueries.xl) {
      return {
        width: `${calc(
          (windowWidth - heroContainerMediaQueries.xl) / 2 + 132
        )}px`,
        minWidth: `${calc(
          (windowWidth - heroContainerMediaQueries.xl) / 2 + 132
        )}px`,
      };
    } else if (windowWidth >= heroContainerMediaQueries.md) {
      return {
        width: `${calc(
          (windowWidth - heroContainerMediaQueries.xl) / 2 - 16
        )}px`,
        minWidth: `${calc(
          (windowWidth - heroContainerMediaQueries.xl) / 2 - 16
        )}px`,
      };
    } else {
      return {
        marginLeft: `${calc(
          (windowWidth - heroContainerMediaQueries.md) / 2 - 24
        )}px`,
      };
    }
  };

  return <div className={`${className} ${first ? "first" : "last"}`} style={getStyle()} />;
};
